export default __webpack_public_path__ + "static/media/IMG_5584.69eb0828.jpg";